import { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { isToday } from 'noddi-util';

/** How often the booking page refreshes the visit while it is under way. */
export const SERVICE_DAY_REFETCH_INTERVAL_MS = 60_000;

type VisitFields = Pick<BookingRecordDetailsCustomer, 'completedAt' | 'isCancelled' | 'deliveryWindowStartsAt'>;

export const getIsVisitClosed = (booking: Pick<VisitFields, 'completedAt' | 'isCancelled'>): boolean =>
  !!booking.completedAt || booking.isCancelled;

/** The service day with the visit still open: the only time the visit moves, so the only time to poll. */
export const getIsVisitLive = (booking: VisitFields): boolean =>
  isToday(booking.deliveryWindowStartsAt) && !getIsVisitClosed(booking);
